const callHelp =
  "Skontaktuj się z pracownikiem pomocy technicznej pod adresem <a href='mailto:e-budownictwo@gunb.gov.pl'>e-budownictwo@gunb.gov.pl</a>";
// const iconAlert = '<i class="mdi v-icon mdi-alert-outline">';
export const commonAppMessages = {
  fileError: `<p class="bold-500">Nie udało się przesłać pliku. </p> ${callHelp}`,
  roleAcceptError: `<p class="bold-500">Nie udało się zatwierdzić przyjęcia roli. </p>  ${callHelp}`,
  getDataError: `<p class="bold-500">Nie udało się pobrać danych. </p> ${callHelp}`
};

export function getMessageByCode(code) {
  return commonAppMessages[code] || "Wystąpił błąd";
}
